import type { TabAccent } from "./tabs.types.js";

/**
 * Static class lookups for the active tab's module accent so Tailwind's
 * content scanner sees every variant literally — never interpolate `accent`
 * into a class string. Split out of `TabStripItem` (PB-5176 d14) so that file
 * stays under the 200-line soft cap.
 */
export const ACTIVE_INDICATOR: Record<TabAccent, string> = {
  "pb-gold": "bg-pb-gold",
  "pb-teal": "bg-pb-teal",
  "pb-cyan": "bg-pb-cyan",
  "pb-purple": "bg-pb-purple",
  "pb-amber": "bg-pb-amber",
  "pb-red": "bg-pb-red",
  "pb-module-solve": "bg-pb-module-solve",
  "pb-module-vsm": "bg-pb-module-vsm",
  "pb-module-hoshin": "bg-pb-module-hoshin",
  "pb-module-lama": "bg-pb-module-lama",
  "pb-module-studio": "bg-pb-module-studio",
};
export const ACTIVE_ICON: Record<TabAccent, string> = {
  "pb-gold": "text-pb-gold-text",
  "pb-teal": "text-pb-teal-text",
  "pb-cyan": "text-pb-cyan-text",
  "pb-purple": "text-pb-purple-text",
  "pb-amber": "text-pb-amber-text",
  "pb-red": "text-pb-red-text",
  "pb-module-solve": "text-pb-module-solve-text",
  "pb-module-vsm": "text-pb-module-vsm-text",
  "pb-module-hoshin": "text-pb-module-hoshin-text",
  "pb-module-lama": "text-pb-module-lama-text",
  "pb-module-studio": "text-pb-module-studio-text",
};
/**
 * Identity glow under the active underline (ADR-0092). Only a module accent
 * glows — a status hue must not glow like an identity, so the legacy members
 * are empty. High contrast drops it, as the generated glow composites do.
 */
export const ACTIVE_GLOW: Record<TabAccent, string> = {
  "pb-gold": "",
  "pb-teal": "",
  "pb-cyan": "",
  "pb-purple": "",
  "pb-amber": "",
  "pb-red": "",
  "pb-module-solve":
    "shadow-[0_0_10px_0_hsl(var(--pb-module-solve)/0.6)] hc:shadow-none",
  "pb-module-vsm":
    "shadow-[0_0_10px_0_hsl(var(--pb-module-vsm)/0.6)] hc:shadow-none",
  "pb-module-hoshin":
    "shadow-[0_0_10px_0_hsl(var(--pb-module-hoshin)/0.6)] hc:shadow-none",
  "pb-module-lama":
    "shadow-[0_0_10px_0_hsl(var(--pb-module-lama)/0.6)] hc:shadow-none",
  "pb-module-studio":
    "shadow-[0_0_10px_0_hsl(var(--pb-module-studio)/0.6)] hc:shadow-none",
};
export const NEUTRAL_ACTIVE_ICON = "text-pb-text";
export const NEUTRAL_ACTIVE_INDICATOR = "bg-pb-text-muted";
